// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"147":"1cde6d81","460":"ffd6c83a","862":"bc3b7abc","965":"2a67fc86"}[chunkId] + ".css";
};